import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "@common/axios";
import {UserContext} from "@context/UserContext";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import {TemplateContext} from "@common/context/TemplateContext";
import {ShortcutContext} from "@common/context/ShortcutContext";
import {BrandContext} from "@context/BrandContext";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import useCurrentShortcut from "@hooks/useCurrentShortcut";

const StudentToDoCalendarDashboardWidget = props => {
    const {className} = props;
    const [isLoading, setLoading] = useState(false);
    const [todoList, setTodoList] = useState([]);
    const localizer = momentLocalizer(moment);
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {loadShortcutByUrl} = useCurrentShortcut();

    useEffect(() => {
        setLoading(true);
        if (user.userId !== undefined) {
            axios.get('/web/ui/todo/getUserToDoList')
                .then(response => {
                    setTodoList(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, []);

    const onSelectEvent = (todo) => {
        if(todo === undefined) {
            return;
        }

        loadShortcutByUrl(todo.url);
    };

    const CustomEvent = ({ event }) => {
        const todoTypeStr = event.toDoType === 'TRAIL' ? brandConfig.taskName : brandConfig[event.toDoType.toLowerCase()+'Name'];
        const tipStr = todoTypeStr + '\n' + event.title + '\n' + event.assignerName;
        return (
            <div className={"rbc-event-" + event.toDoType.toLowerCase()} title={tipStr}>
                {todoTypeStr}: {event.title}
            </div>
        )
    };

    return (
        <DashboardWidget
            title={
                <>
                    <svg className="ch-icon-sm" viewBox="0 0 128 128">
                        <use href="#tests-icon"></use>
                    </svg>
                    <span>To Do Calendar</span>
                </>
            }
            className={className}
            isLoading={isLoading}>
            <div className={'ch-dashboard-blk-body ch-dashboard-blk-calendar'}>
                <Calendar
                    localizer={localizer}
                    events={todoList}
                    components={{event: CustomEvent}}
                    startAccessor="startDate"
                    endAccessor="endDate"
                    views={{month: true}}
                    onSelectEvent={onSelectEvent}
                    popup
                />
            </div>
        </DashboardWidget>
    )
}

export default StudentToDoCalendarDashboardWidget;